export default class extends HTMLElement {
  connectedCallback () {
    if (this.dataset.signature === 'true') {
      const text = this.field.querySelector('.signature-proof-text')
      const fit = () => {
        if (!text) return
        let size = 9
        text.style.fontSize = size + 'px'
        while ((text.scrollHeight > text.clientHeight + 1 || text.scrollWidth > text.clientWidth + 1) && size > 2) {
          size -= 0.25
          text.style.fontSize = size + 'px'
        }
      }
      this.proofObserver = new ResizeObserver(fit)
      this.proofObserver.observe(this.field)
      fit()
      return
    }
    const originalFontValue = this.field.style.fontSize

    if (this.field.scrollHeight > this.field.clientHeight) {
      this.field.style.fontSize = `calc(${originalFontValue} / 1.5)`
      this.field.style.lineHeight = `calc(${this.field.style.fontSize} * 1.3)`

      if (this.field.scrollHeight > this.field.clientHeight) {
        this.field.style.fontSize = `calc(${originalFontValue} / 2.0)`
        this.field.style.lineHeight = `calc(${this.field.style.fontSize} * 1.3)`
      }
    }

    this.field.classList.remove('hidden')
  }

  disconnectedCallback () {
    this.proofObserver?.disconnect()
  }

  get field () {
    return this.closest('field-value')
  }
}
